import React from "react";
import { Helmet } from "react-helmet-async";
import "./consultation.css";
import phoneImg from "../../../assets/medical/appointment/phone-call.png";
import emailImg from "../../../assets/medical/appointment/email.png";

const Consultation = () => {
  // Create structured data for consultation service
  const consultationStructuredData = {
    "@context": "https://schema.org",
    "@type": "MedicalService",
    "name": "Laboratóriumi vizsgálati konzultáció",
    "serviceType": "Orvosi konzultáció",
    "provider": {
      "@type": "MedicalOrganization",
      "name": "Bálint Analitika Laboratórium",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Kondorfa utca 6.",
        "addressLocality": "Budapest",
        "postalCode": "1116",
        "addressRegion": "XI. kerület",
        "addressCountry": "HU"
      }
    },
    "availableChannel": {
      "@type": "ServiceChannel",
      "serviceUrl": "https://balintanalitika.hu/orvosdiagnosztika/konzultacio",
      "servicePhone": "+36-20-254-2591",
      "serviceSmsNumber": "+36-20-254-2591"
    },
    "employee": {
      "@type": "Person",
      "name": "Dr. Kormányos Emília",
      "jobTitle": "Orvos konzultáns",
      "image": "https://balintanalitika.hu/assets/medical/about/team/management/drkormanyosemilia.png"
    }
  };

  return (
    <>
      <Helmet>
        <title>Orvosi konzultáció | Bálint Analitika Laboratórium | Budapest XI. kerület</title>
        <meta 
          name="description" 
          content="Orvosi konzultáció a Bálint Analitika laboratóriumban. Laborvizsgálatok kiértékelése, tanácsadás és vizsgálati eredmények megbeszélése szakértő orvosunkkal Budapest XI. kerületében." 
        />
        <meta
          name="keywords"
          content="orvosi konzultáció, laboreredmény értékelés, laboratóriumi vizsgálat tanácsadás, Bálint Analitika, Budapest XI. kerület"
        />
        <link 
          rel="canonical" 
          href="https://balintanalitika.hu/orvosdiagnosztika/konzultacio"
        />
        <script type="application/ld+json">
          {JSON.stringify(consultationStructuredData)}
        </script>
      </Helmet>

      <main className="consultation-page">
        <div className="container consultation-container">
          <header>
            <h1 className="heading-primary navbar-margin">
              Orvosi konzultáció laboratóriumi eredményekről
            </h1>
          </header>

          <section className="consultation-wrapper">
            <div className="consultation-text">
              <p className="consultation-tex-content">
                Szívesen állunk rendelkezésére a laboratóriumi vizsgálatokkal
                kapcsolatos kérdések megválaszolásában, illetve eredményeik
                kiértékelésében a budapesti XI. kerületben található laboratóriumunkban. 
                Minden vizsgálatunk ára tartalmaz egy konzultációt is.
              </p>
              <p className="consultation-tex-content">
                Konzultációnkat azoknak ajánljuk, akik <strong>megelőzés</strong>{" "}
                vagy már <strong>meglévő panaszok</strong> feltárása céljából
                szeretnének laboratóriumi vizsgálatokat végeztetni, de nem tudják
                mely vizsgálatokat, vizsgálati csomagot lenne érdemes választani.
                Szakértő orvosunk segít eligazodni a laborvizsgálatok között és értelmezni
                a kapott eredményeket.
              </p>
            </div>

            <h2 className="consultation-contact-text-header">
              Konzultációval kapcsolatban kérjük keresse:
            </h2>
            
            <article className="consultation-contact-box" itemScope itemType="https://schema.org/Person">
              <div className="consultation-contact-box-body">
                <h3 className="consultation-contact-text-title" itemProp="name">
                  <strong>Dr. Kormányos Emília</strong>
                </h3>
                <p className="consultation-contact-text-body">
                  <strong>Telefon:</strong> <a href="tel:+3612053044" itemProp="telephone">+36 1 205 3044</a>
                </p>
                <p className="consultation-contact-text-body">
                  <strong>Mobil:</strong> <a href="tel:+36202542591" itemProp="telephone">+36 20 254 2591</a>
                </p>
                <p className="consultation-contact-text-body">
                  <strong>E-mail:</strong> <a href="mailto:orvosdiagnosztika@balintanalitika.hu" itemProp="email">orvosdiagnosztika@balintanalitika.hu</a>
                </p>
                <p className="consultation-contact-text-body">
                  <strong>Fogadási idő:</strong> <span itemProp="workHours">10:00-14:00 (hétfőtől péntekig)</span> - 
                  <strong> Előzetes időpont egyeztetés szükséges!</strong>
                </p>
                <p className="consultation-contact-text-body">
                  <strong>Helyszín:</strong> <span itemProp="workLocation">Bálint Analitika Laboratórium, 1116 Budapest, Kondorfa utca 6.</span>
                </p>
                
                <div className="consultation-contact-button-wrapper">
                  <a
                    href="mailto:orvosdiagnosztika@balintanalitika.hu"
                    className="btn btn-sm consultation-contact-btn"
                    aria-label="Email küldése Dr. Kormányos Emíliának"
                    title="Email küldése konzultációs időpont egyeztetéshez"
                  >
                    <span aria-hidden="true">
                      <img 
                        src={emailImg} 
                        alt="E-mail ikon"
                        className="consultation-contact-btn-icon"
                        width="24"
                        height="24"
                        loading="lazy"
                      />
                    </span>
                    E-mailt írok
                  </a>
                  
                  <a
                    href="tel:+36202542591"
                    className="btn btn-sm consultation-contact-btn"
                    aria-label="Telefonhívás Dr. Kormányos Emíliához"
                    title="Konzultációs időpont egyeztetés telefonon"
                  >
                    <span aria-hidden="true">
                      <img 
                        src={phoneImg} 
                        alt="Telefon ikon"
                        className="consultation-contact-btn-icon"
                        width="24"
                        height="24"
                        loading="lazy"
                      />
                    </span>
                    Telefonálok
                  </a>
                </div>
              </div>
              
              <img
                src="/assets/medical/about/team/management/drkormanyosemilia.png"
                alt="Dr. Kormányos Emília, orvos konzultáns a Bálint Analitika laboratóriumban"
                className="consultation-contact-img"
                width="200"
                height="250"
                loading="lazy"
                itemProp="image"
              />
            </article>
            
            <section className="consultation-benefits">
              <h2 className="consultation-benefits-heading">A konzultáció előnyei</h2>
              <ul className="consultation-benefits-list">
                <li>Személyre szabott vizsgálati terv készítése</li>
                <li>Laboreredmények részletes értelmezése</li>
                <li>Szakértői tanácsadás az eredmények alapján</li>
                <li>További vizsgálatok ajánlása, ha szükséges</li>
                <li>Egészségügyi állapot nyomon követése</li>
              </ul>
            </section>
          </section>
        </div>
      </main>
    </>
  );
};

export default Consultation;